import { Tabs as MuiTabs } from '@mui/material'
import Tab from '@mui/material/Tab'
import { styled } from '@mui/material/styles'
import { Container } from 'components/ui'
import styles from './Tabs.module.scss'

export type TabData = {
  label: string
  badgeColor?: string
  badgeContent?: string
  filterValue?: string
  id?: string
}

export type TabDataLabel = TabData & {
  formatLabel: string
}

type MuiTabProps = {
  label: string
  value: number | string
  key: string
  iconPosition?: 'top' | 'start' | 'end' | 'bottom'
  icon?: any
  id?: string
}

const MuiTab = styled((props: MuiTabProps) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: 'none',
    minWidth: 0,
    fontWeight: 500,
    width: 'auto',
    minHeight: '45px',
    [theme.breakpoints.up('sm')]: {
      minWidth: 0,
    },
    marginRight: theme.spacing(1),
  })
)

type TabsProps = {
  /** The tabData is an array of objects containing data for each tab, including the label, badge color, badge content, and filter value. */
  tabData: TabData[]
  /** The value is used to indicate the currently selected tab in the Tabs component. It is passed as a prop to the Material UI MuiTabs component.*/
  value: number
  /** The iconPosition is an optional prop that determines the position of the icon (if present) relative to the label. It can be one of four values: 'top', 'start', 'end', or 'bottom'.*/
  iconPosition?: 'top' | 'start' | 'end' | 'bottom'
  /** The containerClass is an optional CSS class name to apply to the container element.*/
  containerClass?: string
  /** The containerSx is an optional object containing additional styles to apply to the container element. This uses the Material UI "sx" prop for styling.*/
  containerSx?: any
  /** The handleChange is a function that handles changes to the selected tab. It takes in an event object and the new value (index of the selected tab) as arguments.*/
  handleChange: (event: React.SyntheticEvent, newValue: number) => void
  id?: string
}

const Tabs = (props: TabsProps) => {
  const {
    tabData,
    value,
    handleChange,
    iconPosition = 'end',
    containerClass,
    containerSx,
  } = props
  return (
    <Container
      sx={{ position: 'relative', ...containerSx }}
      className={containerClass}
    >
      <MuiTabs value={value} onChange={(e, val) => handleChange(e, val)}>
        {tabData?.map((item, index) => (
          <MuiTab
            key={`key-${index}`}
            icon={
              item.badgeColor && (
                <Container
                  className={styles.badge}
                  sx={{ background: item.badgeColor }}
                >
                  12
                </Container>
              )
            }
            value={index}
            label={item.label}
            iconPosition={iconPosition}
            id={item.id}
          />
        ))}
      </MuiTabs>
    </Container>
  )
}

export default Tabs
